<template>
	<div>
		<isogd-doc-in-point v-for="doc in docs" :doc="doc" :key="doc.key"></isogd-doc-in-point>
	</div>
</template>
<script>
	import IsogdDocInPoint from "./IsogdDocInPoint";
	export default {		
		props: {
			docs: {
				type: Array,
				required: true
			}
		},
		data() {
			return {
				sharedState: {
					activeDoc: null
				}
			}
		},
		components: {
			IsogdDocInPoint
		}		
	}
</script>